/**
 * CitationList Component
 * Displays references with proper schema markup
 * Enhances medical authority and trustworthiness
 */

import { CITATIONS } from '@/libs/seo/citations';

export function CitationList({ citationKeys }) {
  if (!citationKeys || citationKeys.length === 0) return null;

  const citations = citationKeys
    .map((key) => CITATIONS[key])
    .filter(Boolean);

  if (citations.length === 0) return null;

  return (
    <div className="citations border-t-2 border-gray-200 mt-8 pt-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">References</h3>
      <ol className="list-decimal list-inside space-y-3">
        {citations.map((citation, index) => (
          <li key={index} className="text-sm text-gray-700">
            <span className="font-medium">{citation.source}</span>
            {citation.description && (
              <span className="text-gray-600"> - {citation.description}</span>
            )}
            {citation.url && (
              <>
                {' '}
                <a
                  href={citation.url}
                  target={citation.external ? '_blank' : '_self'}
                  rel={citation.external ? 'noopener noreferrer' : undefined}
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  {citation.external ? '(External Link)' : '(View)'}
                </a>
              </>
            )}
            {citation.date && (
              <span className="text-gray-500 text-xs ml-2">
                ({citation.date})
              </span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}
